/**
 * ## Tabs Controller
 *
 * @module src/controllers/offline
 */

"use strict";

const notification = require("../../components/notification");
const layout = require("../../components/layout");
const modal = require("../../components/modal");
const conf = require("../../config");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  kd.on("_socket.connected", (data) => {
    notification.destroy();
    $("#disconnect_main").html("Online");
    $("#disconnect_main").css("background-color", "#03AB5A");
    TweenMax.to("#disconnect_main", conf.vars.interfaceSpeed * 2, {
      bottom: "-40px",
      ease: Power2.easeIn,
      onComplete: hide,
      delay: 1,
    });
  });
  kd.on("_socket.disconnect", (data) => {
    $("#disconnect_main").html("Offline");
    $("#disconnect_main").css("background-color", "#A50000");
    $("#disconnect_main").css("display", "block");
    TweenMax.to("#disconnect_main", conf.vars.interfaceSpeed * 2, {
      bottom: "50px",
      ease: Power2.easeOut,
    });
    const opt = {
      position: "top",
      width: "90%",
      seconds: 10,
      h1: l.translate("Disconnected: Running in Offline mode"),
      body: l.translate(
        "It is important to know what this means for your operation."
      ),
      buttons: [
        {
          description: "Learn More",
          value: "learn",
        },
        {
          description: "OK, I got it.",
          value: "cancel",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      if (value == "learn") {
        displayInfo(kd);
      }
      notification.destroy();
    });
  });
};

const displayInfo = (kd) => {
  const opt2 = {
    width: "90%",
    type: "dialog",
    h1: l.translate("Offline mode"),
    body: l.translate(
      "This device has been disconnected from the Guest List servers. " +
        "This could be because of your wifi, internet, or the Guest List servers are temporarily " +
        "unreachable. If other devices at your location are also offline, it is important to " +
        "only use a single device. While offline sms text messages, automated calls, and email " +
        "alerts will " +
        "not be sent out. Guest List will continue to attempt to reconnect automatically and " +
        "the red `Offline` message will disappear when this device has reconnected and synced " +
        "all the operations while performed while offline. At that time other devices can be " +
        "used again."
    ),
    buttons: [
      {
        description: l.translate("I Understand"),
        value: "close",
      },
    ],
  };

  const data2 = {
    kd,
  };
  modal.create(opt2, data2, (err, value) => {
    modal.destroy();
  });
};

const hide = () => {
  $("#disconnect_main").css("display", "none");
  layout.resize();
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/offline/index.js
 **/